import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  currentStep: number
  nextStep: () => void
  prevStep: () => void
  resetStep: () => void
}

export const FormSurveyContext = createContext<IContext>({
  currentStep: 1,
  nextStep: () => {},
  prevStep: () => {},
  resetStep: () => {},
})

let persistedStep = 1

export const FormSurveyContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<number>(persistedStep)

  const nextStep = () => {
    setCurrentStep(currentStep + 1)
    persistedStep = currentStep + 1
  }

  const prevStep = () => {
    setCurrentStep(currentStep - 1)
    persistedStep = currentStep - 1
  }

  const resetStep = () => {
    setCurrentStep(1)
    persistedStep = 1
  }

  return (
    <FormSurveyContext.Provider
      value={{
        currentStep,
        nextStep,
        prevStep,
        resetStep,
      }}>
      {children}
    </FormSurveyContext.Provider>
  )
}
